import { Form } from 'react-bootstrap';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from 'redux/store';
import { fetchSchedulingWindows } from '../../../../redux/slices/scheduling_windowsSlice';

type Props = {
  selectedValue?: number | null; // e.g. 42 or null
  defaultValue?: number | null; // fallback if selectedValue is undefined
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  queryParams?: Record<string, any>;
};

const ScheduleWindowsSelect = ({ selectedValue, defaultValue = null, onChange, placeholder = '-- (no schedule window)', queryParams }: Props) => {
  const dispatch = useAppDispatch();
  const items = useSelector((state: RootState) => state.schedulingWindow.items);

  useEffect(() => {
    dispatch(fetchSchedulingWindows(queryParams || {}));
  }, [dispatch, queryParams]);

  // Keep the control "value" as a string, matching option values below
  const value = selectedValue == null ? '' : String(selectedValue ?? defaultValue ?? '');

  const options = useMemo(() => {
    return (items ?? [])
      .filter((win: any) => (win.name ?? '').trim().length > 0)
      .sort((a: any, b: any) =>
        (a.name ?? '').localeCompare(b.name ?? '', undefined, {
          sensitivity: 'base',
        })
      );
  }, [items]);

  return (
    <Form.Group className="mb-2" controlId="formSchedulingWindows">
      <Form.Label>Schedule Window</Form.Label>
      <Form.Select
        aria-label="scheduling-windows-select"
        name="scheduling_window_id" // <-- use the ID field name
        value={value}
        onChange={onChange}
      >
        <option value="">{placeholder}</option>
        {options.map((win: any) => {
          const key = String(win.scheduling_window_id);
          // IMPORTANT: value is the ID (as a string)
          return (
            <option key={key} value={key}>
              {win.name} ({win.zone_name ?? '—'})
            </option>
          );
        })}
      </Form.Select>
    </Form.Group>
  );
};

export default ScheduleWindowsSelect;
